Asynchronously posts a job ad for a new position opening.

This combines the `createPositionOpening` & `postPositionProfileForOpening` mutations in a single operation.
